export default "__VITE_ASSET__cb4bd89a__"